import React from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { TextField } from "@mui/material";
import { EstimateDto } from "./types";

export function AmountField({ index }: { index: number }) {
  const { control, setValue } = useFormContext<EstimateDto>();

  /* ① 실시간 값 구독 */
  const qty       = useWatch({ control, name: `content.items.${index}.qty` });
  const unitPrice = useWatch({ control, name: `content.items.${index}.unitPrice` });

  /* ② 계산 → 폼에 반영 */
  const amount = (qty || 0) * (unitPrice || 0);

  React.useEffect(() => {
    setValue(`content.items.${index}.amount`, amount, { shouldValidate: true });
  }, [amount, index, setValue]);

  /* ③ 읽기 전용 표시 */
  return (
    <Controller
      name={`content.items.${index}.amount`}
      control={control}
      render={({ field, fieldState }) => {
        /* ① 화면에 보여 줄 값: 0 → "" , 그 외는 3자리 콤마 */
        const display = amount === 0 || amount === undefined
        ? ""
        : Number(field.value).toLocaleString("ko-KR");  // 12,345 처럼
        return (
          <TextField
            {...field}
            label="금액"
            type="text"
            value={display}                    // 화면에 표시
            InputProps={{ readOnly: true }}    // 사용자는 수정 못 함
            sx={{ minWidth: 200 }}
          />
        )
      }}
    />
  );
}
